import ReactMap from "../../../shared/map/map";
import {
    OverlayView,
    OverlayViewF,
    PolylineF
} from "@react-google-maps/api";
import mapData from "../../../data/mapData";
import {forwardRef, useEffect, useImperativeHandle, useState} from "react";
import MarkerInfo from "../../../shared/markerInfo";

const TripDetailsMap = ({
                            tripMapData = {
                                tripCords: [],
                                alerts: []
                            },
                            DVRVideoPathNodes,
                            selectedAlert,
                            getSelectedAlert,
                            tripId = '',
                            panToLatLng,
                            onAlertVideoClick = () => {}
                        }, ref) => {
    const [activeAlert, setActiveAlert] = useState(selectedAlert);
    const [hideInfo, setHideInfo] = useState(false);
    const [mapCenter, setMapCenter] = useState();
    const getCurrentAlert = (alert) => {
        setActiveAlert(alert);
        getSelectedAlert(alert);
        setHideInfo(true);
    }
    const handleMarkerClick = (alert) => {
        setActiveAlert(alert);
        getSelectedAlert(alert);
        setHideInfo(false);
    }

    const mapClick = () => {
        setHideInfo(true);
    }
    const preventClicks = (e) => {
        e.stopPropagation();
    }

    useEffect(() => {
        const centerCord = tripMapData?.tripCords?.length > 0 ?
        tripMapData?.tripCords[Math.round(tripMapData?.tripCords?.length / 2)] : mapData?.center;
        setMapCenter(centerCord);
    }, [])



    return (
        <ReactMap center={mapCenter} zoom={12} panToLatLng={panToLatLng} fitBound={tripMapData?.tripCords} onclick={mapClick}>
            {tripMapData?.tripCords?.length > 0 &&
                <PolylineF path={tripMapData?.tripCords}
                           options={{
                               strokeColor: "#44A9E1",
                               strokeOpacity: 1,
                               strokeWeight: 3
                           }}
                />

            }
            {tripMapData?.tripCords?.length > 0 &&
                <OverlayViewF
                    position={tripMapData?.tripCords[0]}
                    mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                >
                    <div className={'custom-marker start-marker'}></div>
                </OverlayViewF>
            }

            {tripMapData?.tripCords?.length > 0 &&
                <OverlayViewF
                    position={tripMapData?.tripCords[tripMapData?.tripCords?.length - 1]}
                    mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                >
                    <div className={'custom-marker end-marker map-marker'}></div>
                </OverlayViewF>
            }
            {
                <PolylineF path={DVRVideoPathNodes}
                           options={{
                               strokeColor: "#44A9E1",
                               strokeOpacity: 0.4,
                               strokeWeight: 15
                           }}
                />
            }
            {
                tripMapData?.alerts?.filter(alert => alert?.isActive !== false)?.map((alert) =>
                    <OverlayViewF
                        key={alert?.externalAlertId}
                        position={{
                            lat: alert.location.coordinates[1],
                            lng: alert.location.coordinates[0],
                        }}
                        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                    >
                        <MarkerInfo handleMarkerClick={handleMarkerClick}
                                    onAlertVideoClick={onAlertVideoClick}
                                    preventClicks={preventClicks}
                                    alert={alert}
                                    selectedAlert={selectedAlert}
                                    hideInfoOnMapClick={hideInfo}
                                    tripId={tripId}/>
                    </OverlayViewF>
                )
            }


            {/*{selectedAlert && showInfo && */}
            {/*    <OverlayViewF*/}
            {/*        position={{*/}
            {/*            lat: selectedAlert?.location?.coordinates[1],*/}
            {/*            lng: selectedAlert?.location?.coordinates[0],*/}
            {/*        }}*/}
            {/*        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}*/}
            {/*    >*/}
            {/*        <MarkerInfo onAlertVideoClick={onAlertVideoClick} onclick={preventClicks} alert={selectedAlert} tripId={tripId}/>*/}
            {/*    </OverlayViewF>*/}
            {/*}*/}

        </ReactMap>
    )
}

export default forwardRef(TripDetailsMap);
